import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer__badge" }
const _hoisted_2 = { class: "row g-0 justify-content-center align-items-center" }
const _hoisted_3 = { class: "col-auto" }
const _hoisted_4 = {
  href: "https://www.co2neutralwebsite.de/crt/dispcust/c/5373/l/4",
  target: "_blank"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Unsere Website ist CO")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("sub", null, "2", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" neutral. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconTree = _resolveComponent("IconTree")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, [
          _createVNode(_component_IconTree),
          _hoisted_5,
          _hoisted_6,
          _hoisted_7
        ])
      ])
    ])
  ]))
}